function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createSWStoreWithShapeNodeMap } from "./createSWStoreWithShapeNodeMap";
import { LoadableMap } from "./loadables";
import { NodeMap } from "./nodes";
import { SWPaywallRecordType, createPaywallId } from "./records";
// import { createSWStore } from "../../editor/lib/config/createSWStore"
// import { defaultNodeUtils } from "../../lib/nodes"
export const createEmptyStore = (options = {})=>{
    const store = createSWStoreWithShapeNodeMap(_object_spread_props(_object_spread({}, options), {
        defaultName: "Untitled",
        loadableTypeMap: LoadableMap,
        nodeTypeMap: NodeMap
    }));
    return store;
};
export const createBlankStore = ()=>{
    const paywallId = createPaywallId("paywall");
    return createEmptyStore({
        initialData: {
            [paywallId]: SWPaywallRecordType.create({
                id: paywallId,
                version: 0,
                editable: true
            })
        }
    });
};
export const createBlankSnapshot = ()=>{
    return createBlankStore().getSnapshot();
};
